import { all } from 'redux-saga/effects';

import fetchFloorActivity from './fetchFloorActivity';

export default function* () {
    yield all([fetchFloorActivity()]);
}
